import React from 'react';
import { useSearchParams } from 'react-router-dom';

function Login() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  const handleLogin = () => {
    window.location.href = '/api/auth/login';
  };

  return (
    <div className="login-container">
      <img src="/SunPower_WhiteYellow.png" alt="SunPower Logo" className="brand-logo" />
      <div className="login-card">
        <h1>Helpdesk Portal</h1>
        <p>Azure AD Password Reset & MFA Management</p>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <button className="login-btn" onClick={handleLogin}>
          <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

export default Login;
